require('./hireCardRevolvingSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const { PROC_CARD_REVOLVING } = require('utilities/tagging');

class HireCardRevolvingSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardRevolving-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardRevolving-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;
        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-revolving-success__summary">
                <div className="col-xs-6 hire-card-revolving-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-revolving-success__summary-title"
                        value="hireCardRevolving-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-revolving-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-revolving-success__summary-title"
                        value="hireCardRevolving-summarySelectedLimit"
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-revolving-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-revolving-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-revolving-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-revolving-success__summary-title"
                        value="hireCardRevolving-summaryPaymentMethod"
                    />
                    <div className="col-xs-12 hire-card-revolving-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        const { immHireCardRevolving, immShippingAddress } = this.props;
        let textElement;
        let titleKey;

        const pendingAnalysis = immHireCardRevolving.get('hiringStatus') === PENDING;

        if (pendingAnalysis) {
            titleKey = 'hireCardRevolving-successTitlePending';
            textElement = (
                <div className="col-xs-8 hire-card-revolving-success__text">
                    <p>
                        <FormattedText value="hireCardRevolving-successText1Pending" />
                    </p>
                    <FormattedText value="hireCardRevolving-successText2Pending" />
                    <br />
                    <span className="hire-card-revolving-success__phone">
                        <i className="hire-card-revolving-success__phone-icon icon icon-s-llamar" />
                        <FormattedText value="hireCardRevolving-phoneNumberClients" />
                    </span>
                </div>
            );
        } else {
            const address = PersonalDataHelper.getFormattedAddress(immShippingAddress);

            titleKey = 'hireCardRevolving-successTitleCompleted';
            textElement = (
                <div className="col-xs-8 hire-card-revolving-success__text">
                    <FormattedText value="hireCardRevolving-successText1Completed" />
                    <div className="hire-card-revolving-success__address">
                        <i className="hire-card-revolving-success__address-icon icon icon-s-locacion" />
                        {address}
                    </div>
                    <FormattedText value="hireCardRevolving-successText2Completed" />
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url = formatText('hireCardRevolving-successWarningUrl2');
        const text = !!email ? 'hireCardRevolving-successWarningTextSentByEmail' : 'hireCardRevolving-successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="col-xs-12" >
                <OKMessage type="informative">
                    <FormattedText value="hireCardRevolving-successWarningText1" />
                    &nbsp;
                    <OKLink modifier="inline" target="_blank" to={url}>
                        <FormattedText value="hireCardRevolving-successWarningText2" />
                    </OKLink>
                    &nbsp;
                    <FormattedText value="hireCardRevolving-successWarningText3" />
                    <div className="hire-card-revolving-success__message-paragraph">
                        <FormattedText value={text} injectedStrings={injectedString} />
                    </div>
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immHireCardRevolving,
            immProfile,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const wizardSuccessIcon = immHireCardRevolving.get('hiringStatus') === PENDING ? 'pending' : '';

            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardRevolving-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    processType={PROC_CARD_REVOLVING}
                    successMessage={formatText(titleKey)}
                >
                    <article className="hire-card-revolving-success">
                        <div className="row">
                            <div className="col-xs-4">
                                <HireSuccessStepCardImage
                                    className="hire-card-revolving-success__card-image"
                                    immImageData={immImageData}
                                />
                            </div>
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-revolving-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardRevolvingSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardRevolvingSuccess;
